import { useTheme } from '@mui/styles';

type Props = {
  isRead: boolean;
};

export const useSxStyles = (props: Props) => {
  const theme = useTheme();
  const { isRead } = props;

  return {
    creditCardIcon: {
      marginLeft: theme.spacing(),
      color: theme.palette.text.secondary,
    },
    border: { borderBottom: 'solid 1px #ddd' },
    primaryElement: {
      display: 'flex',
    },
    redIcon: {
      marginLeft: theme.spacing(),
      color: '#DC143C',
    },
    notificationContent: {
      color: theme.palette.text.primary,
    },
    notificationRoot: {
      padding: '4px',
      '&:hover': {
        backgroundColor: isRead ? 'inherit' : '#e7f9ff',
      },
    },
    unreadNotificationRoot: {
      backgroundColor: '#e7f9ff',
    },
    icon: { color: ' #025874', cursor: 'pointer' },
    iconSpacing: { marginRight: theme.spacing(0.5) },
    iconButton: { p: theme.spacing(0.25), fontSize: '1rem' },
    actionBox: {
      marginRight: theme.spacing(-1.5),
    },
  };
};
